import titleCaseString from "../../../../utils/titleCaseUtils";
import { useAuth } from "../../../../contexts/AuthContext";
// import ImageCapture from "../../../../components/ImageCapture";
import ImageCaptureMinimal from "../../../../components/ImageCaptureMinimal";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';


// CSS
import "../../../../styles/imagezoom.css";
import ImageHoverPopup from "../../../../components/ImageHoverPopup";


// PDF
/* PDF VIEWER */
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';


/* CSS PDF VIEWER */
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';


const Page5 = ({ formData,setFormData, saveData, prevPage,showSaveButton }) => {
console.log("ssda",formData);

 const [pdfUrl, setPdfUrl] = useState(null);
    useEffect(() => {
        if (formData.scannedImages && formData.scannedImages.type === "application/pdf") {
            const url = URL.createObjectURL(formData.scannedImages);
            setPdfUrl(url);
            return () => URL.revokeObjectURL(url);
        }
    }, [formData.scannedImages]);




 const defaultLayoutPluginInstance = defaultLayoutPlugin({
    renderToolbar: () => null, // Disable the toolbar completely
  });

  const navigate       = useNavigate();
  const { user }       = useAuth();
  const lawyerId       = user.user_id;
  const lawyerPhoto    = user.user_profile_photo
  const lawyerFullName = `${user.first_name} ${user.middle_name ?? ""} ${user.last_name}`;
 

  const DateFormatter = ({ date }) => {
    const formatDate = (date) => {
      const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
  
      // Format the date without the time
      return new Date(date).toLocaleDateString('en-US', options);
    };
  
    return <div>{formatDate(date)}</div>;
  };

const handleImageChange = (image,keyName) => {
    setFormData({ ...formData, [keyName]: image });
};

const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const gotoDashboard =()=>{
    navigate('/certificates/');
  }

  return (
    <div className="step-content">
      <div>
        <div className="d-flex flex-wrap justify-content-between align-items-center">
          <div className="d-flex flex-column justify-content-center">
            <h4 className="mb-1 mt-3">REVIEW INFORMATION</h4>
            <p className="text-muted">check the data before proceeding</p>
          </div>
        </div>
        <div className="row">
          
          <div className="container-xxl flex-grow-1" style={{fontSize: "1rem"}}>



            <div className="row">

              <div className="col-12 mb-md-0 mb-4">
                <div className="card shadow-none">
                  {/* PAGE 1 */}
                  <div className="card-body">
                    <div className="row">

                    <h4 className="bg-label-primary py-2 mx-0 rounded">Page 1</h4>


                      <div className="col-md-12">
                        <h5 className="mb-2">Document Info</h5>
                        <table className="table table-bordered" style={{borderRadius:10}}>
                          <tbody>
                            <tr>
                              <td className="pe-3">
                                <i className="bx bx-book" /><span className="fw-medium mx-2">Document Name:</span>
                              </td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.documentName.toUpperCase()==="TITLE YOUR DOCUMENT" ? formData.documentTitle?.toUpperCase() : formData.documentName.toUpperCase()}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-book-open" /><span className="fw-medium mx-2">Document No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.documentNo}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-bookmark-alt" /><span className="fw-medium mx-2">Page No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.pageNo}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-book-open" /><span className="fw-medium mx-2">Book No:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.bookNo}</td>
                            </tr>
                            
                            <tr>
                            <td className="pe-3"><i className="bx bx-user" /><span className="fw-medium mx-2">Document For:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{titleCaseString(formData.requestFor.toUpperCase())}</td>
                            </tr>
                            <tr>
                            <td className="pe-3"><i className="bx bx-group" /><span className="fw-medium mx-2">Relationship:</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{titleCaseString(formData.relationshipToBeneficiary?.toUpperCase() ?? "")}</td>
                            </tr>



                            <tr>
                              <td className="ps-0 border-0" colSpan={2}>
                                <h5 className="my-2">Questions</h5>
                              </td>
                            </tr>

                         
                            
                            <tr>
                              <td className="pe-3"><i className="bx bx-radio-circle-marked" /><span className="fw-medium mx-2">Affiant is in the Philippines?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.insidePhilippines.toUpperCase()}</td>
                            </tr>
                            <tr>
                              <td className="pe-3"><i className="bx bx-radio-circle-marked" /><span className="fw-medium mx-2">Will the notarized document be used in the Philippines or abroad?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.question1.toUpperCase()}</td>
                            </tr>
                            <tr>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked" /><span className="fw-medium mx-2">Is the document signed by all signatories by hand (wet-signed)?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.question2.toUpperCase()}</td>
                            </tr>
                            
                            <tr>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked" /><span className="fw-medium mx-2">Were the signatories in the Philippines when they signed the document?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.question3.toUpperCase()}</td>
                            </tr>
                            <tr>
                            <td className="pe-3"><i className="bx bx-radio-circle-marked" /><span className="fw-medium mx-2">Are the signatories currently in the Philippines?</span></td>
                              <td className="fw-bold"><i className="bx bx-chevrons-right" />{formData.question4?.toUpperCase()}</td>
                            </tr>

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  

                  {/* PAGE 2 - Uploaded Documents / Requirements */}
                  <div className="card-body">
                    <div className="row">
                      <h4 className="bg-label-primary py-2 mx-0 rounded">Scanned & Uploaded Documents</h4>
                      <div className="col-md-12">
                       <div className="row d-flex justify-content-center align-items-start border rounded mx-1" style={{ maxHeight: 300, overflowY: "scroll", minHeight: 365 }}>
                       
                         
                        {pdfUrl &&
                            <Worker workerUrl="../js/pdf.worker.min.js">
                              <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                          </Worker>
                        }

                        {formData.scannedImages.length > 0 &&
                          <div className="alert bg-light d-flex rounded-0 position-sticky top-0 " role="alert" style={{ zIndex: 1 }}>
                            <span className='fw-bold fs-6'>PAGES TO UPLOAD : {formData.scannedImages.length}</span>
                          </div>
                        }

                        {formData.scannedImages.length > 0 && (

                          formData.scannedImages.map((img, index) => (
                            <div key={index} className="rounded shadow px-0 mx-3 mt-4 mb-2" style={{ width: "11.25rem", borderRadius: "0, 0, 10,10" }}>

                              <div className="p-0 m-0 w-100 ">
                                <img src={URL.createObjectURL(img)} alt={`Captured ${index}`} className='img-fluid p-0 m-0 rounded-top bg-dark h-100' style={{ minHeight: 180, maxHeight: 180, objectFit: "contain" }} />
                                <div className="fw-bolder ms-2">
                                  page{img.name.replace(/page|\.png/g, "")}.png
                                </div>
                                <div className="dz-size pt-0" >
                                  <strong>{(img.size / (1024 * 1024)).toFixed(2)}</strong> MB
                                </div>
                              </div>
                            </div>
                          ))
                        )}
                       </div>
                      </div>




                    </div>
                  </div>


                  <div className="card-body">
                    <div className="row">
                      <h4 className="bg-label-primary py-2 mx-0 rounded">Valid IDs</h4>
               
                          <div className="col-md-6">
                            <div className="card   h-100">
                              {formData.governmentId && 

                              <img
                                    src={URL.createObjectURL(formData.governmentId)} alt={`Valid ID`} 
                                    style={{cursor: "pointer", maxHeight:550,objectFit:"cover"}}
                                    className=" img-fluid hover-zoom "
                                />

                              }

                              <div className="table-responsive rounded-bottom  w-100">
                                <table className="table table-borderless table-striped rounded-bottom m-0 w-100" >
                                  <tr>
                                    <th>
                                      <td colSpan={2} className="fw-bold">1st Party ID Details</td>
                                    </th>
                                  </tr>
                                  <tbody>

                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-collection" /><span className="fw-medium mx-2">Type:</span>
                                      </td>
                                      <td className="fw-bold"> {formData.idType} </td>
                                    </tr>

                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-id-card" /><span className="fw-medium mx-2">ID No:</span>
                                      </td>
                                      <td className="fw-bold"> {formData.idNo} </td>
                                    </tr>

                                    <tr>
                                      <td style={{ overflow: "hidden" }}>
                                        <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date issued:</span>
                                      </td>
                                      <td className="fw-bold"> {<DateFormatter date={formData.dateIssued?.toString() ?? ''} />} </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      {formData.secondPartyGovernmentId &&
                        < div className="col-md-6">
                          <div className="card   h-100">
                            {formData.secondPartyGovernmentId && 
                            <img
                                    src={URL.createObjectURL(formData.secondPartyGovernmentId)} alt={`Valid ID`} 
                                    style={{cursor: "pointer", maxHeight:550,objectFit:"cover"}}
                                    className=" img-fluid hover-zoom "
                                />
                            }

                            <div className="table-responsive rounded-bottom  w-100">
                              <table className="table table-borderless table-striped rounded-bottom m-0 w-100" >
                                <tr>
                                  <th>
                                    <td colSpan={2} className="fw-bold">2nd party ID Details</td>
                                  </th>
                                </tr>
                                <tbody>

                                  <tr>
                                    <td style={{ overflow: "hidden" }}>
                                      <i className="bx bx-collection" /><span className="fw-medium mx-2">Type:</span>
                                    </td>
                                    <td className="fw-bold"> {formData.secondPartyIdType} </td>
                                  </tr>

                                  <tr>
                                    <td style={{ overflow: "hidden" }}>
                                      <i className="bx bx-id-card" /><span className="fw-medium mx-2">ID No:</span>
                                    </td>
                                    <td className="fw-bold"> {formData.secondPartyIdNo} </td>
                                  </tr>

                                  <tr>
                                    <td style={{ overflow: "hidden" }}>
                                      <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date issued:</span>
                                    </td>
                                    <td className="fw-bold"> {formData.secondPartyDateIssued ? <DateFormatter date={formData.secondPartyDateIssued?.toString() ?? null} /> : ""} </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                  


                  {/* PAGE INFO */}
                  <div className="card-body">
                    <div className="row">
                    <h4 className="bg-label-primary py-2 mx-0 rounded">Affiants Information</h4>


{/* 1st Party */}
                      <div className="col-md-6">

                        <table className="table table-bordered"  >
                          <tr className="border">
                            <th colSpan={2} className=" p-2 bg-label-secondary fw-bold fs-6">1st Party Information</th>
                          </tr>

                          <tbody>
                            <tr>
                              <td colSpan={2}>
                                <div className="d-flex flex-column align-items-center">
                                  {formData.principalImage && <img src={URL.createObjectURL(formData.principalImage)} alt={`Principal`} className="rounded-pill shadow" height={200} width={200} />}
                                </div>

                              </td> 

                            </tr>



                            <tr>
                              <td width={"50%"}>
                                <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span>
                              </td>
                              <td className="fw-bold">
                                {titleCaseString(
                                  (formData.firstName +
                                    (formData.middleName ? ' ' + formData.middleName : '') +
                                    ' ' +
                                    formData.lastName +
                                    (formData.suffix ? ' ' + formData.suffix : '')
                                  )
                                )}
                              </td>

                            </tr>

                            <tr>
                              <td>
                                <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span>
                              </td>
                              <td className="fw-bold">{<DateFormatter date={formData.birthday?.toString() ?? Date.now()} />}</td>
                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span>
                              </td>
                              <td className="fw-bold">{titleCaseString(formData.gender.toUpperCase())}</td>

                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                              </td>
                              <td className="fw-bold">{formData.contactNumber}</td>

                            </tr>
                            <tr>
                              <td>
                                <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                              </td>
                              <td className="fw-bold">{formData.email}</td>

                            </tr>

                            <tr>
                              <td>
                                <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                              </td>

                              <td>
                              {formData.principalImageSignature && 
                                <ImageHoverPopup
                                  imageSrc={formData.principalImageSignature}
                                  altText="Signature"
                                  height={30}
                                  label="SIGNATURE"
                                />
                              }
                              </td>
                            </tr>
                          </tbody>
                        </table>

                      </div>

{/* 2nd Party */}
                      {formData.secondPartyFirstName && formData.secondPartyLastName &&
                        <div className="col-md-6">
                          <table className="table table-bordered"  >
                            <tr className="border">
                              <th colSpan={2} className=" p-2 bg-label-secondary fw-bold fs-6">2nd Party Information</th>
                            </tr>

                            <tbody>
                              <tr>
                                <td colSpan={2}>
                                  <div className="d-flex flex-column align-items-center">
                                    {formData.secondPartyPrincipalImage && <img src={URL.createObjectURL(formData.secondPartyPrincipalImage)} alt={`Principal`} className="rounded-pill shadow" height={200} width={200} />}
                                  </div>
                                </td>

                              </tr>



                              <tr>
                                <td width={"50%"}>
                                  <i className="bx bx-edit" /><span className="fw-medium mx-2">Full Name:</span>
                                </td>
                                <td className="fw-bold">
                                  {formData.secondPartyFirstName && formData.secondPartyLastName && titleCaseString(
                                    (formData.secondPartyFirstName +
                                      (formData.secondPartyMiddleName ? ' ' + formData.secondPartyMiddleName : '') +
                                      ' ' +
                                      formData.secondPartyLastName +
                                      (formData.secondPartySuffix ? ' ' + formData.secondPartySuffix : '')
                                    )
                                  )}
                                </td>

                              </tr>

                              <tr>
                                <td>
                                  <i className="bx bx-calendar-alt" /><span className="fw-medium mx-2">Birthday:</span>
                                </td>
                                <td className="fw-bold">{formData.secondPartyBirthday && <DateFormatter date={formData.secondPartyBirthday?.toString() ?? Date.now()} />}</td>
                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-male-female" /><span className="fw-medium mx-2">Gender:</span>
                                </td>
                                <td className="fw-bold">{titleCaseString(formData.secondPartyGender?.toUpperCase())}</td>

                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-phone" /><span className="fw-medium mx-2">Contact:</span>
                                </td>
                                <td className="fw-bold">{formData.secondPartyContactNumber}</td>

                              </tr>
                              <tr>
                                <td>
                                  <i className="bx bx-envelope" /><span className="fw-medium mx-2">Email:</span>
                                </td>
                                <td className="fw-bold">{formData.secondPartyEmail}</td>

                              </tr>

                              <tr>
                                <td>
                                  <i className="bx bx-pencil" /><span className="fw-medium mx-2">Signature:</span>
                                </td>

                                <td>
                                  {formData.secondPartyPrincipalImageSignature &&
                                    <ImageHoverPopup
                                      imageSrc={formData.secondPartyPrincipalImageSignature}
                                      altText="Signature"
                                      height={30}
                                      label="SIGNATURE"
                                    />
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                      }
{/*               
                      <tr>
                                <td className="fw-bold">Country:</td>
                                <td className="fw-bold">{formData.country.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Region:</td>
                                <td>{formData.region.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Province:</td>
                                <td>{formData.province.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">City/Mun:</td>
                                <td>{formData.cityMunicipality.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Brgy:</td>
                                <td>{formData.barangay.toUpperCase()}</td>
                              </tr> */}




                      <div className="card-body">
                        <div className="row">
                          <h4 className="bg-label-primary py-2 mx-0 rounded">Witness(es)</h4>

                          {formData.witnessFirstFullname &&
                            <div className="d-flex pt-4 bg-label-secondary rounded-pill">
                              <div className="col mb-0  d-flex flex-column align-items-center">
                                <h6 className="pb-2 fw-bold">WITNESS 1</h6>
                                {formData.witnessFirstPhoto && <img src={URL.createObjectURL(formData.witnessFirstPhoto)} alt={`Valid ID`} className="rounded" height={200} width={200} />}
                                <h6 className="pb-0 mb-0 fw-bold mt-2">{formData.witnessFirstFullname.toUpperCase()}</h6>

                                {formData.witnessFirstPhotoSignature && <img src={formData.witnessFirstPhotoSignature} alt={`Witness 1 Signature`} className="rounded mb-0" height={150} width={200} />}
                                <h6 className="pb-0 mb-0 fw-bold mt-0">Signature</h6>

                              </div>

                              {formData.witnessSecondFullname &&
                                (
                                  <div className="col mb-0  d-flex flex-column align-items-center">
                                    <h6 className="pb-2 fw-bold">WITNESS 2</h6>
                                    {formData.witnessSecondPhoto && <img src={URL.createObjectURL(formData.witnessSecondPhoto)} alt={`Valid ID`} className="rounded" height={200} width={200} />}
                                    <h6 className="pb-0 mb-0 fw-bold mt-2">{formData.witnessSecondFullname.toUpperCase()}</h6>
                                    

                                    {formData.witnessSecondPhotoSignature && <img src={formData.witnessSecondPhotoSignature} alt={`Witness 2 Signature`} className="rounded" height={150} width={200} />}
                                    <h6 className="pb-2 fw-bold mt-0">Signature</h6>

                                  </div>
                                )
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>


                 


                  <div className="card-body">
                    <div className="row p-0">
                      {/* <div className="col-xl-6 col-md-12 col-sm-5 col-12 mb-xl-0 mb-md-4 mb-sm-0 mb-4">
                      <h4 className="text-info">Page 3: Personal Info</h4>

                        <div className="table-responsive border rounded">
                          <table className="table border-none rounded m-0">
                        
                            <tbody>
                              <tr>
                                <td className="fw-bold">First name:</td>
                                <td>{formData.firstName.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Middle name:</td>
                                <td>{formData.middleName?.toUpperCase()}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Last name:</td>
                                <td>{formData.lastName.toUpperCase()}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Birthday:</td>
                                <td>{<DateFormatter date={formData.birthday?.toString() ?? Date.now()} />}</td>
                              </tr>
                              <tr>
                                <td className="fw-bold">Gender:</td>
                                <td>{formData.gender.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Country:</td>
                                <td>{formData.country.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Region:</td>
                                <td>{formData.region.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Province:</td>
                                <td>{formData.province.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">City/Mun:</td>
                                <td>{formData.cityMunicipality.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Brgy:</td>
                                <td>{formData.barangay.toUpperCase()}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Contact #:</td>
                                <td>{formData.contactNumber}</td>

                              </tr>
                              <tr>
                                <td className="fw-bold">Email:</td>
                                <td>{formData.email}</td>

                              </tr>

                            </tbody>
                          </table>
                        </div>
                      </div> */}

 
                    {/* <h4 className="bg-label-primary py-2 mx-0 rounded">Payment & Other Info</h4> */}



                      <div className="col-md-12 col-lg-6">

                        <table className="table table-bordered"  >
                          <tr className="border">
                            <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Payment Info</th>
                          </tr>

                          <tbody>
                            <tr style={{height:60}}>
                              <td width={"50%"}><i className="bx bx-purchase-tag-alt" /><span className="fw-medium mx-2">Amount:</span> </td>
                              <td className="fw-bold"> {formData.amount} </td>
                            </tr>

                            <tr style={{height:60}}>
                              <td>
                                <i className="bx bx-hash" /><span className="fw-medium mx-2">Ref #:</span>
                              </td>
                              <td className="fw-bold">{formData.referenceNo?.toUpperCase()}</td>
                            </tr>
                            <tr style={{height:60}}>
                              <td>
                                <i className="bx bx-calendar" /><span className="fw-medium mx-2">Date Paid:</span>

                              </td>
                              <td className="fw-bold">{<DateFormatter date={formData.datePaid?.toString() ?? Date.now()} />}</td>

                            </tr>
                            <tr style={{height:60}}>
                              <td>
                                <i className="bx bx-dollar-circle" /><span className="fw-medium mx-2">Payment Method:</span>
                              </td>
                              <td className="fw-bold">{formData.paymentMethod?.toUpperCase()}</td>

                            </tr>
                            <tr style={{height:60}}>
                              <td>
                                <i className="bx bx-edit-alt" /><span className="fw-medium mx-2">Description / Remarks:</span>
                              </td>
                              <td className="fw-bold">{formData.description?.toUpperCase()}</td>

                            </tr>


                          </tbody>
                        </table>

                      </div>


                      <div className="col-md-12 col-lg-6">

                        <table className="table table-bordered"  >
                          <tr className="border">
                            <th colSpan={2} className=" p-2 bg-label-primary fw-bold fs-6">Lawyer Image</th>
                          </tr>

                          <tbody>
                            <ImageCaptureMinimal btnCameraTitle="Open Camera" title="Profile Image from your Account" subtitle={titleCaseString(lawyerFullName)} onImageChange={handleImageChange} keyName="lawyerImage" preLoadedImage={formData.lawyerImage ?? lawyerPhoto} useSignaturePad={false} hasUploadButton={true} hasRemoveButton={true} />
                          </tbody>
                               
                        </table>

                      </div>


 

 
                    </div>
                  </div>


                 
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <span className="fw-medium">Note: </span>
                        <span>
                          Please make sure you encoded the correct information before proceeding. Once you proceed, you cannot edit the information anymore.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Invoice */}

            </div>

          </div>


        </div>
      </div>

      



      {showSaveButton &&
        <div className="col-12 d-flex justify-content-between">
          <button className="btn btn-label-secondary btn-prev" onClick={prevPage}>
            <i className="bx bx-chevron-left bx-sm ms-sm-n2" />
            <span className="align-middle d-sm-inline-block d-none">
              Previous
            </span>
          </button>
          <button className="btn btn-primary btn-next" onClick={saveData}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              Save
            </span>
            <i className="bx bx-save bx-sm me-sm-n2" />
          </button>
        </div>
      }


      
      {!showSaveButton &&
        <div className="col-12 d-flex justify-content-end">

          <button className="btn btn-primary btn-next" onClick={gotoDashboard}>
            <span className="align-middle d-sm-inline-block  d-none  me-sm-1">
              End Transaction
            </span>
            <i className="bx bx-save bx-sm me-sm-n2" />
          </button>
        </div>
      }

    </div>
  );
};

export default Page5;
